// Pure helpers for the payout-request minimum-amount setting. No `bun:sqlite`
// import here on purpose: this file is safe to pull into the browser bundle
// (see src/lib/service-price-limits-shared.ts for the same split).

export const PAYOUT_REQUEST_MIN_KEY = "payout_request_min_amount";
export const PAYOUT_REQUEST_MIN_CEILING = 100000;

/** Prazno, nepostojeće ili nula znači "bez praga". */
export function parsePayoutRequestMin(value: string | null | undefined): number | null {
  if (value === null || value === undefined) return null;
  const trimmed = value.trim();
  if (trimmed === "") return null;
  const n = Number(trimmed.replace(",", "."));
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n * 100) / 100;
}

export function formatPayoutRequestMin(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
}

/** Vraća bosansku poruku o grešci, ili null kada je patch ispravan. */
export function validatePayoutRequestMinPatch(body: Record<string, string>): string | null {
  if (!(PAYOUT_REQUEST_MIN_KEY in body)) return null;
  const raw = String(body[PAYOUT_REQUEST_MIN_KEY] ?? "").trim();
  if (raw === "") return null;
  const n = Number(raw.replace(",", "."));
  if (!Number.isFinite(n) || n < 0) {
    return "Minimalni iznos za zahtjev mora biti broj veći ili jednak nuli.";
  }
  if (n > PAYOUT_REQUEST_MIN_CEILING) {
    return `Minimalni iznos za zahtjev ne može biti veći od ${PAYOUT_REQUEST_MIN_CEILING} KM.`;
  }
  return null;
}
